import { render, staticRenderFns } from "./sms-template-list.vue?vue&type=template&id=1b97a3fc"
import script from "./sms-template-list.vue?vue&type=script&lang=js"
export * from "./sms-template-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports